import { defineMessages } from 'react-intl';

export default defineMessages({
	email: {
		id: 'login.email',
		defaultMessage: "Email",
	},
	emailPlaceholder: {
		id: 'login.email.placeholder',
		defaultMessage: "enter email address",
	},
	password: {
		id: 'login.password',
		defaultMessage: "Password",
	},
	passwordPlaceholder: {
		id: 'login.password.placeholder',
		defaultMessage: "enter password",
	},
	login_error_email_missing: {
		id: 'login.error.email.missing',
		defaultMessage: "Please enter an email address",
	},
	login_error_email_invalid: {
		id: 'login.error.email.invalid',
		defaultMessage: "Please enter a valid email address",
	},
	login_error_password_missing: {
		id: 'login.error.password.missing',
		defaultMessage: "Please enter your password",
	},
	login_error_failed: {
		id: 'login.error.failed',
		defaultMessage: "Login failed",
	},
	login_error_incorrect: {
		id: 'login.error.incorrect',
		defaultMessage: "Incorrect Email or Password",
	},
	login_error_lockout_warning: {
		id: 'login.error.lockout.warning',
		defaultMessage: "Incorrect Email or Password. After 5 failed attempts your account will be locked.",
	},
	login_error_lockedout: {
		id: 'login.error.lockedout',
		defaultMessage: "You have exceeded the maximum number of login attempts. Your account will be locked for {lockoutPeriod} minutes.",
	},
	forgot_password_request_submitted: {
		id: 'forgot_password.request.submitted',
		defaultMessage: "Request submitted. We will send you an email with a password reset link.",
	},
	forgot_password_error_failed: {
		id: 'forgot_password.error.failed',
		defaultMessage: "Request failed.",
	},
	reset_password_error_failed: {
		id: 'reset_password.error.failed',
		defaultMessage: "Password reset failed.",
	},
	reset_password_confirm: {
		id: 'reset_password.confirm',
		defaultMessage: "Re-enter password.",
	},
	reset_error_password_mismatch: {
		id: 'reset_password.error.password.mismatch',
		defaultMessage: "Password mismatch",
	},
});



// WEBPACK FOOTER //
// ./src/locales/login.js